module.exports = __webpack_public_path__ + "img/cbabd5234333504a22d7fd4ce17e8fc4.png";